import React from 'react';
import {navigateHook} from "../../../../../hooks/use-navigate.js";

const DispatchListContent = ({ data }) => {
    const navigate = navigateHook();

    return (
        <>
            <div>
                <div className="chart mt-3"><span className="chart-title"> Lista de despachos </span></div>

                <table id={'dispatch-list-data'} className="table report-table mt-2" sheet-name={'Lista de despachos'}>
                    <thead className="thead-background table-break-word">
                        <tr className={"text-left"}>
                            <th className={'w-[10%]'}>Talão</th>
                            <th className={'w-[12%]'}>Agente</th>
                            <th className={'w-[12%]'}>D/H do despacho</th>
                            <th className={'w-[66%]'}>Campos não preenchidos</th>
                        </tr>
                    </thead>

                    <tbody className={"bg-white"}>
                        { data.map((element, index) => {

                            return (
                                <tr key={index}>
                                    <td className={'w-[10%]'}>{element.numbercheckbook ? <a onClick={() => navigate(`/despacho/dispatch/form/${element.dispatch_id}`, true)} rel="noreferrer" className={'inner-link'}>{element.numbercheckbook}</a> : 'Sem talão'}</td>
                                    <td className={'w-[12%]'}>{element.user_name}</td>
                                    <td className={'w-[12%]'}>{element.dispatch_start}</td>
                                    <td className={'w-[66%]'}>{element.without_info}</td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>
        </>
    );
};

export default DispatchListContent;